import { useEffect } from "react";
import { useHMSNotifications } from "@100mslive/react-sdk";

export default function HMSNotificationHandler() {
  const notification = useHMSNotifications();

  useEffect(() => {
    if (notification?.type === "error") {
      const err = notification.data;
      console.error("Global HMS Error:", err);
      alert(`HMS Error: ${err.message || "An unexpected error occurred."}`);
    }
  }, [notification]);

  return null;
}
